<div class="flex flex-col gap-3">
  <div class="bg-[var(--content-background)] rounded-lg flex flex-col gap-4 p-[var(--content-padding)]"
    [ngClass]="{
      'sm:gap-8 sm:flex-row sm:justify-between sm:items-center':
        enableHorizontalDisplay,
    }"
  >
    <div
      class="flex flex-col gap-3"
      [ngClass]="{
        'sm:gap-8 sm:flex-row': enableHorizontalDisplay,
      }"
    >
      <dl class="p-0">
        <dt><small>Erschienen</small></dt>
        <dd>
          {{ downloadInformation.published_date | date: 'dd.MM.yyyy' }}
        </dd>
      </dl>

      <dl class="p-0">
        <dt><small>Dateiname</small></dt>
        <dd class="break-all">{{ downloadInformation.file_name }}</dd>
      </dl>

      <dl class="p-0">
        <dt><small>Dateigröße</small></dt>
        <dd>{{ downloadInformation.file_size || 0 | fileSize }}</dd>
      </dl>
    </div>

    <section class="p-0">
      <button
        mat-button
        color="primary"
        (click)="startDownload(downloadInformation)"
        class="min-w-44"
      >
        Datei herunterladen
      </button>
    </section>
  </div>

  @if (downloadInformation.checksum) {
    <dl class="p-0">
      <dt><small>Prüfsumme</small></dt>
      <dd>
        <div class="flex items-center">
          <span class="break-all">{{ downloadInformation.checksum }}</span>
          <button
            mat-button
            color="secondary"
            class="gap-0 min-w-10 ml-2"
            (click)="copyToClipboard(downloadInformation.checksum)"
            aria-label="Prüfsumme in Zwischenablage kopieren"
            matTooltip="Prüfsumme in Zwischenablage kopieren"
          >
            <mat-icon svgIcon="fi-kopieren-20"></mat-icon>
          </button>
        </div>
      </dd>
    </dl>
  }

  @if (downloadInformation.teaser && showTeaser) {
    <section class="p-0">
      <p [innerHTML]="downloadInformation.teaser" class="break-words"></p>
    </section>
  }
</div>
